/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-27 02:41:46
 *
 *******************************************************/
// @flow

import React from 'react';

import _ from 'lodash';

import WeglotTranslate from 'src/assets/images/integration/weglot-translate.png';
import Langify from 'src/assets/images/integration/langify.png';
import LangShop from 'src/assets/images/integration/langshop.png';

import ShopifyMultiCurrency from 'src/assets/images/integration/shopify-multi-currency.png';
import BestCurrencyConverter from 'src/assets/images/integration/best-currency-converter.png';
import MLVAutoCurrencySwitcher from 'src/assets/images/integration/mlv-auto-currency-switcher.png';

import WishlistPlus from 'src/assets/images/integration/wishlist-plus.png';
import SmartWishlist from 'src/assets/images/integration/smart-wishlist.png';
import WishlistKing from 'src/assets/images/integration/wishlist-king.png';
import IWishList from 'src/assets/images/integration/i-wishlist.png';
import ReviewsLoyaltyWishlist from 'src/assets/images/integration/reviews-loyalty-wishlist.png';

import FlairProductBadgesLabels from 'src/assets/images/integration/flair-product-badges-labels.png';
import ProductLabels from 'src/assets/images/integration/product-labels.png';
import Fera from 'src/assets/images/integration/fera.png';

import YotpoReviews from 'src/assets/images/integration/yotpo-reviews.png';
import StampedReviews from 'src/assets/images/integration/stamped-reviews.png';
import AliReview from 'src/assets/images/integration/ali-review.png';
import JudgemeProductReviews from 'src/assets/images/integration/judgeme-product-reviews.png';
import RivyoProductReview from 'src/assets/images/integration/rivyo-product-review.png';
import Ryviu from 'src/assets/images/integration/ryviu.png';
import ProductReviewsShopify from 'src/assets/images/integration/product-reviews-shopify.png';
import Okendo from 'src/assets/images/integration/okendo.png';
import LooxReviews from 'src/assets/images/integration/loox-reviews.png';
import LAIAliExpress from 'src/assets/images/integration/lai-ali-express.png';
import ReviewsIO from 'src/assets/images/integration/reviews-io.png';

import QuickviewBySecomap from 'src/assets/images/integration/quick-view-by-secomapp.png';
import ProductCompare from 'src/assets/images/integration/product-compare.png';
import DiscountNinja from 'src/assets/images/integration/discount-ninja.png';
import Vajro from 'src/assets/images/integration/vajro.png';
import Shopney from 'src/assets/images/integration/shopney.png';

import GemPages from 'src/assets/images/integration/gempages.png';

import Klaviyo from 'src/assets/images/integration/klaviyo.svg';

import YotpoCard from 'src/components/containers/tools/integration/yotpo-card';
import StampedioCard from 'src/components/containers/tools/integration/stampedio-card';
// import AliCard from 'src/components/containers/tools/integration/ali-card';
import ReviewCard from 'src/components/containers/tools/integration/review-card';
import GemPagesCard from 'src/components/containers/tools/integration/gempages-card';

import KlaviyoCard from 'src/components/containers/tools/integration/klaviyo-card';

import appBanner02 from 'src/assets/images/integration/app-banner-01.png';
import appBanner01 from 'src/assets/images/integration/app-banner-02.png';

// Small icon app review without padding
import YotpoReviewsSmall from 'src/assets/images/integration/small/yotpo-reviews.png';
import StampedReviewsSmall from 'src/assets/images/integration/small/stamped-reviews.png';
import AliReviewSmall from 'src/assets/images/integration/small/ali-review.png';
import JudgemeProductReviewsSmall from 'src/assets/images/integration/small/judgeme-product-reviews.png';
import RivyoProductReviewSmall from 'src/assets/images/integration/small/rivyo-product-review.png';
import ReviewsLoyaltyWishlistSmall from 'src/assets/images/integration/small/reviews-loyalty-wishlist.png';
import RyviuSmall from 'src/assets/images/integration/small/ryviu.png';
import ProductReviewsShopifySmall from 'src/assets/images/integration/small/product-reviews-shopify.png';
import OkendoSmall from 'src/assets/images/integration/small/okendo.png';
import LooxReviewsSmall from 'src/assets/images/integration/small/loox-reviews.png';
import LAIAliExpressSmall from 'src/assets/images/integration/small/lai-ali-express.png';
import ReviewsIOSmall from 'src/assets/images/integration/small/reviews-io.png';
// import IntegrationCard from 'src/components/containers/tools/integration/integration-card';
import AliCard from 'src/components/containers/tools/integration/ali-card';
import { getShop } from 'src/helpers';
import ProductLabelsCard from 'src/components/containers/tools/integration/product-label-card';

export const AppType = {
  reviews: 'reviews',
  currencies: 'currencies',
  languages: 'languages',
  others: 'others',
  labels: 'labels',
  wishlists: 'wishlists',
  smsEmail: 'smsEmail'
};

export const AppTypeOnlyAutoOnV3 = ['currencies', 'languages', 'others', 'labels', 'wishlists'];

export const AppNameShow = {
  yotpo: 'Yotpo Product Reviews & UGC',
  stamped: 'Stamped Product Reviews & UGC',
  aliReview: 'Ali Reviews ‑ Product Reviews',
  judgeme: 'Judge.me Product Reviews',
  rivyo: 'Rivyo Product Reviews & QA',
  reviewsLoyaltyWishlist: 'Growave: Loyalty & Wishlist',
  ryviu: 'Ryviu: Product Reviews & QA',
  prs: 'Product Reviews',
  loox: 'Loox Product Reviews & Photos',
  LAIAliExpress: 'LAI Ali Reviews Product Review',
  ReviewsIO: 'REVIEWS.io Product Reviews',
  best: 'BEST Currency Converter',
  auto: 'Auto Currency Switcher',
  okendo: 'Okendo: Product Reviews & UGC',
  flair: 'Flair Product Badges + Labels',
  deco: 'DECO Product Labels & Badges'
};

export const aliReviewSupport = [
  'ultamodan.myshopify.com',
  'eidonsurfswim.myshopify.com',
  'skyeswim.myshopify.com',
  'bestvalue-resume.myshopify.com',
  'ruff-houzin.myshopify.com',
  'ultamodan-au.myshopify.com',
  'ultamodan-us.myshopify.com',
  'selesta-sake.myshopify.com',
  'nogibjj.myshopify.com',
  'factory21-id.myshopify.com',
  'vip-luggage2021.myshopify.com',
  'vip-lhb2021.myshopify.com',
  'prado-rugs.myshopify.com',
  'marie-dubie.myshopify.com',
  'uopochi.myshopify.com',
  'neon-shisha.myshopify.com',
  'sake-ya-online-demo.myshopify.com',
  'little-holmes.myshopify.com',
  'glamberryboutique.myshopify.com',
  'yossrafitness4.myshopify.com',
  'ayopa-indonesia.myshopify.com',
  'crocsvietnam.myshopify.com',
  'supporto-cuffie.myshopify.com',
  'maison-galile.myshopify.com',
  'tejjen1.myshopify.com',
  'slo-tech.myshopify.com',
  'allouttech.myshopify.com',
  'hair-store-3902.myshopify.com',
  'affiliate-test123.myshopify.com',
  'bigmercadao.myshopify.com',
  'dslshop.myshopify.com',
  'sweat-plaid-6093.myshopify.com',
  'customstore12569.myshopify.com',
  'getme-fit.myshopify.com',
  'psychedelic-rhapsody.myshopify.com',
  'softwarecw.myshopify.com',
  'francis-m-doe-vip-clothing.myshopify.com',
  'lapink-5041.myshopify.com',
  'a5c772-2.myshopify.com',
  'bbbf34-2.myshopify.com',
  'bruteimpact.myshopify.com',
  'lemonade935681.myshopify.com',
  'e39dec.myshopify.com',
  'flip-mobile-martinique.myshopify.com',
  'totse420.myshopify.com',
  'socialhead-store-real.myshopify.com',
  'zdesign-inc.myshopify.com',
  'immortalgroup.myshopify.com',
  'sunielle.myshopify.com',
  '54b0db.myshopify.com',
  '642548-2.myshopify.com',
  '55d6c2.myshopify.com',
  'f3c072.myshopify.com',
  'd68956-3.myshopify.com',
  'bc-dev-v2-bonnie-07.myshopify.com',
  'bc-dev-v2-helen4.myshopify.com'
];

export let MULTI_LANGUAGE = [
  {
    name: 'AdminHTML.Integration.Constants.multipleLanguage_ShopifyTranslate_Name',
    icon: ShopifyMultiCurrency,
    description: 'AdminHTML.Integration.Constants.multipleLanguage_ShopifyTranslate_Description',
    appListingURL: 'https://apps.shopify.com/translate-and-adapt',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9359387-shopify-translate-adapt-language-integration-guide',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appName: 'shopify-translate-adapt'
  },
  {
    name: 'AdminHTML.Integration.Constants.multipleLanguage_WeglotTranslate_Name',
    icon: WeglotTranslate,
    description: 'AdminHTML.Integration.Constants.multipleLanguage_WeglotTranslate_Description',
    appListingURL: 'https://apps.shopify.com/weglot',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9356306-weglot-integration-guide',
    integration: 'AdminHTML.Integration.Constants.manualIntegration',
    appName: 'weglot',
    isManually: true
  },
  {
    name: 'AdminHTML.Integration.Constants.multipleLanguage_Langify_Name',
    icon: Langify,
    description: 'AdminHTML.Integration.Constants.multipleLanguage_Langify_Description',
    appListingURL: 'https://langify-app.com/discount/boostcommerce',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360156-langify-integration-guide',
    integration: 'AdminHTML.Integration.Constants.manualIntegration',
    appName: 'langify',
    isManually: true
  },
  {
    name: 'AdminHTML.Integration.Constants.multipleLanguage_LangShop_Name',
    icon: LangShop,
    description: 'AdminHTML.Integration.Constants.multipleLanguage_LangShop_Description',
    appListingURL: 'https://apps.shopify.com/langshop',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9356370-langshop-integration-guide',
    integration: 'AdminHTML.Integration.Constants.manualIntegration',
    appName: 'langshop',
    isManually: true
  }
];

export let MULTI_CURRENCY = [
  {
    name: 'AdminHTML.Integration.Constants.multiCurrency_ShopifyMultiCurrency_Name',
    icon: ShopifyMultiCurrency,
    description: 'AdminHTML.Integration.Constants.multiCurrency_ShopifyMultiCurrency_Description',
    appListingURL: 'https://help.shopify.com/en/manual/payments/multi-currency',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9359978-shopify-multi-currency-integration-guide',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appName: 'multi-currency'
  },
  {
    name: 'AdminHTML.Integration.Constants.multiCurrency_BestCurrencyConverter_Name',
    icon: BestCurrencyConverter,
    description: 'AdminHTML.Integration.Constants.multiCurrency_BestCurrencyConverter_Description',
    appListingURL: 'https://apps.shopify.com/doubly-currency-converter',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9460511-best-currency-converter-integration-guide',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appType: AppType.currencies,
    appName: 'best'
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  },
  {
    name: 'AdminHTML.Integration.Constants.multiCurrency_Auto_Currency_Switcher',
    icon: MLVAutoCurrencySwitcher,
    description: 'AdminHTML.Integration.Constants.multiCurrency_Auto_Currency_Switcher_Description',
    appListingURL: 'https://apps.shopify.com/auto-currency-switcher',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9359997-auto-currency-switcher-integration-guide',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    appType: AppType.currencies,
    appName: 'auto'
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  }
];

export let WISHLIST = [
  {
    name: 'AdminHTML.Integration.Constants.wishlist_WishlistPlus_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: WishlistPlus,
    description: 'AdminHTML.Integration.Constants.wishlist_WishlistPlus_Description',
    appListingURL: 'https://apps.shopify.com/swym-relay',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360695-wishlist-plus-integration-guide',
    // integration: 'AdminHTML.Integration.Constants.autoIntegration',
    // appType: AppType.wishlists,
    appName: 'plus'
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  },
  {
    name: 'AdminHTML.Integration.Constants.wishlist_SmartWishlist_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: SmartWishlist,
    description: 'AdminHTML.Integration.Constants.wishlist_SmartWishlist_Description',
    appListingURL: 'https://apps.shopify.com/smart-wishlist',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360679-smart-wishlist-integration-guide',
    // integration: 'AdminHTML.Integration.Constants.autoIntegration',
    // appType: AppType.wishlists,
    appName: 'smart'
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  },
  {
    name: 'AdminHTML.Integration.Constants.wishlist_ReviewsLoyaltyWishlist_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: ReviewsLoyaltyWishlist,
    description: 'AdminHTML.Integration.Constants.wishlist_ReviewsLoyaltyWishlist_Description',
    appListingURL: 'https://growave.io/?discount_code=60days4boostcommerce',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9464378-growave-wishlist-integration-guide',
    // integration: 'AdminHTML.Integration.Constants.autoIntegration',
    // appType: AppType.wishlists,
    appName: 'growave'
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  },
  {
    name: 'AdminHTML.Integration.Constants.wishlist_WishlistKing_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: WishlistKing,
    description: 'AdminHTML.Integration.Constants.wishlist_WishlistKing_Description',
    appListingURL: 'https://apps.shopify.com/wishlist-king',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360729-wishlist-king-integration-guide',
    // integration: 'AdminHTML.Integration.Constants.autoIntegration',
    // appType: AppType.wishlists,
    appName: 'king'
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  },
  {
    name: 'AdminHTML.Integration.Constants.wishlist_IWishlist_Name',
    icon: IWishList,
    description: 'AdminHTML.Integration.Constants.wishlist_IWishlist_Description',
    appListingURL: 'https://apps.shopify.com/i-wishlist',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360685-iwishlist-integration-guide',
    // integration: 'AdminHTML.Integration.Constants.autoIntegration',
    // appType: AppType.wishlists,
    appName: 'i-wishlist'
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  }
  // {
  //   name: 'AdminHTML.Integration.Constants.wishlist_WishlistShare_Name',
  //   icon: WishListShare,
  //   description: 'AdminHTML.Integration.Constants.wishlist_wishlistShare_Description',
  //   appListingURL: 'https://apps.shopify.com/wishlist-1',
  //   instructionURL: 'https://support.boostcommerce.net/en/articles/9359354-listr-wishlist-reminder-integration-guide',
  //   // integration: 'AdminHTML.Integration.Constants.autoIntegration',
  //   // appType: AppType.wishlists,
  //   appName: 'wishlist-1',
  //   // render: (index, data) => {
  //   //   return <IntegrationCard index={index} data={data} />;
  //   // }
  // }
];

export let PRODUCT_LABELS = [
  {
    name: 'AdminHTML.Integration.Constants.productLabel_FlairProductBadgesLabels_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: FlairProductBadgesLabels,
    description:
      'AdminHTML.Integration.Constants.productLabel_FlairProductBadgesLabels_Description',
    appListingURL: 'https://apps.shopify.com/flair',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360721-flair-product-badges-banners-integration-guide',
    appType: AppType.labels,
    appName: 'flair',
    render: (index, data) => {
      return <ProductLabelsCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productLabel_ProductLabels_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: ProductLabels,
    description: 'AdminHTML.Integration.Constants.productLabel_ProductLabels_Description',
    appListingURL: 'https://apps.shopify.com/product-labels',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360731-deco-product-labels-badges',
    appType: AppType.labels,
    appName: 'deco',
    render: (index, data) => {
      return <ProductLabelsCard index={index} data={data} />;
    }
  }
];

export const PRODUCT_SWATCHES = [[]];

export let PRODUCT_REVIEWS = [
  {
    name: 'AdminHTML.Integration.Constants.productReview_ReviewsIO_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: ReviewsIO,
    smallIcon: ReviewsIOSmall,
    description: 'AdminHTML.Integration.Constants.productReview_ReviewsIO_Description',
    appListingURL: 'https://apps.shopify.com/reviews-co-uk-product-and-merchant-review-collection',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9570801-reviews-io-integration-guide',
    appType: AppType.reviews,
    appName: 'ReviewsIO',
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_YotpoReviews_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: YotpoReviews,
    smallIcon: YotpoReviewsSmall,
    description: 'AdminHTML.Integration.Constants.productReview_YotpoReviews_Description',
    appListingURL:
      'https://apps.shopify.com/yotpo-social-reviews?utm_source=co_marketing&utm_medium=Boostapp&utm_campaign=boost_app_admin',
    instructionURL: 'https://support.boostcommerce.net/en/articles/9360376-yotpo-integration-guide',
    appType: AppType.reviews,
    appName: 'yotpo',
    render: (index, data) => {
      return <YotpoCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_StampedReviews_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: StampedReviews,
    smallIcon: StampedReviewsSmall,
    description: 'AdminHTML.Integration.Constants.productReview_StampedReviews_Description',
    appListingURL: 'https://apps.shopify.com/product-reviews-addon',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360404-stamped-io-integration-guide',
    appType: AppType.reviews,
    appName: 'stamped',
    render: (index, data) => {
      return <StampedioCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_JudgemeProductReviews_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: JudgemeProductReviews,
    smallIcon: JudgemeProductReviewsSmall,
    description: 'AdminHTML.Integration.Constants.productReview_JudgemeProductReviews_Description',
    appListingURL: 'https://judge.me/free-trial/boostcommerce',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9355798-judge-me-integration-guide',
    appType: AppType.reviews,
    appName: 'judgeme',
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_RivyoProductReview_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: RivyoProductReview,
    smallIcon: RivyoProductReviewSmall,
    description: 'AdminHTML.Integration.Constants.productReview_RivyoProductReview_Description',
    appListingURL: 'https://apps.shopify.com/rivyo-product-review',
    instructionURL: 'https://support.boostcommerce.net/en/articles/9360199-rivyo-integration-guide',
    appType: AppType.reviews,
    appName: 'rivyo',
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_ReviewsLoyaltyWishlist_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: ReviewsLoyaltyWishlist,
    smallIcon: ReviewsLoyaltyWishlistSmall,
    description: 'AdminHTML.Integration.Constants.productReview_ReviewsLoyaltyWishlist_Description',
    appListingURL: 'https://growave.io/?discount_code=60days4boostcommerce',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360361-growave-product-review-integration-guide',
    appType: AppType.reviews,
    appName: 'reviewsLoyaltyWishlist',
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_Ryviu_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: Ryviu,
    smallIcon: RyviuSmall,
    description: 'AdminHTML.Integration.Constants.productReview_Ryviu_Description',
    appListingURL: 'https://www.ryviu.com/',
    instructionURL: 'https://support.boostcommerce.net/en/articles/9360207-ryviu-integration-guide',
    appType: AppType.reviews,
    appName: 'ryviu',
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_ProductReviewsShopify_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: ProductReviewsShopify,
    smallIcon: ProductReviewsShopifySmall,
    description: 'AdminHTML.Integration.Constants.productReview_ProductReviewsShopify_Description',
    appListingURL: 'https://apps.shopify.com/product-reviews',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9359384-shopify-product-reviews-integration-guide',
    appType: AppType.reviews,
    appName: 'prs',
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_LooxReviews_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: LooxReviews,
    smallIcon: LooxReviewsSmall,
    description: 'AdminHTML.Integration.Constants.productReview_LooxReviews_Description',
    appListingURL: 'https://loox.io/app/boostcommerce',
    instructionURL: 'https://support.boostcommerce.net/en/articles/9360332-loox-integration-guide',
    appType: AppType.reviews,
    appName: 'loox',
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_Okendo_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: Okendo,
    smallIcon: OkendoSmall,
    description: 'AdminHTML.Integration.Constants.productReview_Okendo_Description',
    appListingURL: 'https://www.okendo.io/forms/demo/?affiliate_id=boostcommerce.net',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360212-okendo-integration-guide',
    appType: AppType.reviews,
    appName: 'okendo',
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_LAIAliExpress_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: LAIAliExpress,
    smallIcon: LAIAliExpressSmall,
    description: 'AdminHTML.Integration.Constants.productReview_LAIAliExpress_Description',
    appListingURL: 'https://partners.smartifyapps.com/apps/lai_reviews/boostcommerce',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360204-lai-aliexpress-reviews-integration-guide',
    appType: AppType.reviews,
    appName: 'LAIAliExpress',
    render: (index, data) => {
      return <ReviewCard index={index} data={data} />;
    }
  },
  {
    name: 'AdminHTML.Integration.Constants.productReview_AliReview_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: AliReview,
    smallIcon: AliReviewSmall,
    description: 'AdminHTML.Integration.Constants.productReview_AliReview_Description',
    appListingURL: 'https://apps.shopify.com/ali-reviews',
    instructionURL: 'https://help.boostcommerce.net/article/418-ali-review',
    appType: AppType.reviews,
    appName: 'aliReview',
    render: (index, data) => {
      const tenantId = getShop();
      if (!_.includes(aliReviewSupport, tenantId)) return null;
      return <AliCard index={index} data={data} />;
    }
  }
];

export const PAGE_BUILDERS = [
  {
    name: 'AdminHTML.Integration.Constants.pageBuilder_GemPages_Name',
    icon: GemPages,
    description: 'AdminHTML.Integration.Constants.pageBuilder_GemPages_Description',
    appListingURL: 'https://apps.shopify.com/gempages',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9359395-gempages-integration-guide',
    render: (index, data) => {
      return <GemPagesCard index={index} data={data} />;
    },
    appName: 'gempages'
  },
  {
    name: 'AdminHTML.Integration.Constants.pageBuilder_Shopney_Name',
    icon: Shopney,
    description: 'AdminHTML.Integration.Constants.pageBuilder_Shopney_Description',
    appListingURL: 'https://apps.shopify.com/shopney-mobile-app',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360624-shopney-integration-guide',
    appName: 'shopney'
  },
  {
    name: 'AdminHTML.Integration.Constants.pageBuilder_Vajro_Name',
    icon: Vajro,
    description: 'AdminHTML.Integration.Constants.pageBuilder_Vajro_Description',
    appListingURL: 'https://apps.shopify.com/vajro?utm_source=from_bcm',
    instructionURL: 'https://support.boostcommerce.net/en/articles/9356300-vajro-integration-guide',
    appName: 'vajro'
  }
];

export const OTHERS = [
  {
    name: 'AdminHTML.Integration.Constants.others_QuickviewBySecomap_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: QuickviewBySecomap,
    description: 'AdminHTML.Integration.Constants.others_QuickviewBySecomap_Description',
    appListingURL: 'https://apps.shopify.com/quick-view',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360724-quick-view-by-secomapp-integration-guide'
    // integration: 'AdminHTML.Integration.Constants.autoIntegration',
    // appType: AppType.others,
    // appName: 'secomapp',
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  },
  {
    name: 'AdminHTML.Integration.Constants.others_ProductCompare_Name',
    icon: ProductCompare,
    description: 'AdminHTML.Integration.Constants.others_ProductCompare_Description',
    appListingURL: 'https://apps.shopify.com/product-compare',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9356526-equate-product-compare-integration-guide'
  },
  {
    name: 'AdminHTML.Integration.Constants.others_DiscountNinja_Name',
    icon: DiscountNinja,
    description: 'AdminHTML.Integration.Constants.others_DiscountNinja_Description',
    appListingURL: 'https://apps.shopify.com/discount-url',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9360736-discount-ninja-integration-guide'
  },
  {
    name: 'AdminHTML.Integration.Constants.productLabel_Fera_Name',
    integration: 'AdminHTML.Integration.Constants.autoIntegration',
    icon: Fera,
    description: 'AdminHTML.Integration.Constants.productLabel_Fera_Description',
    appListingURL: 'https://apps.shopify.com/fera',
    instructionURL:
      'https://support.boostcommerce.net/en/articles/9356337-fera-social-proof-integration-guide'
    // integration: 'AdminHTML.Integration.Constants.autoIntegration',
    // appType: AppType.others,
    // appName: 'fera',
    // render: (index, data) => {
    //   return <IntegrationCard index={index} data={data} />;
    // }
  }
];

export const APPS_BANNERS = [
  {
    image: {
      source: appBanner01
    },
    name: 'appsBanners_Banner1',
    url: 'https://apps.shopify.com/growave?utm_source=partner&utm_medium=banner&utm_campaign=Boost'
  },
  {
    image: {
      source: appBanner02
    },
    name: 'appsBanners_Banner2',
    url: 'https://apps.shopify.com/split-partial-payments?utm_source=boostcommerce'
  }
];

export const SMS_EMAIL = [
  {
    name: 'AdminHTML.Integration.Constants.smsEmail_Klaviyo_Name',
    icon: Klaviyo,
    description: 'AdminHTML.Integration.Constants.smsEmail_Klaviyo_Description',
    appListingURL: 'https://apps.shopify.com/klaviyo-email-marketing',
    instructionURL: 'https://support.boostcommerce.net/en/articles/9359395-gempages-integration-guide',
    render: (index, data) => {
      return <KlaviyoCard index={index} data={data} />;
    },
    appType: AppType.smsEmail,
    appName: 'klaviyo'
  },
];


export const initIntegrationStructure = list => {
  const cloned = _.cloneDeep(list);

  let table = [];
  _.forEach(cloned, (value, key) => {
    if (table.length === 0 || table[table.length - 1].length === 3) table.push([]);
    table[table.length - 1].push(value);
  });
  cloned.length = 0;
  cloned.push.apply(cloned, table);

  return cloned;
};

export const ALL_APP = [
  ...MULTI_LANGUAGE.flat(1),
  ...MULTI_CURRENCY.flat(1),
  ...WISHLIST.flat(1),
  ...PRODUCT_LABELS.flat(1),
  ...PRODUCT_REVIEWS.flat(1),
  ...OTHERS.flat(1)
];

export const REACT_DOM_SCRIPT =
  'https://unpkg.com/react-dom@18.2.0/umd/react-dom.production.min.js';
export const REACT_SCRIPT = 'https://unpkg.com/react@18.2.0/umd/react.production.min.js';
